import posthog from 'posthog-js';

// Initialize PostHog
export function initializeAnalytics() {
  posthog.init('phc_nI4PKuY4qtLfHUr144TOZ5fb2e1wqHSCrnY3wQRw5BC', {
    api_host: 'https://us.i.posthog.com',
    persistence: 'localStorage',
    person_profiles: 'identified_only'
  });
}

// Identify user
export function identifyUser(username: string) {
  if (!username) return;
  
  // Use username as the distinct_id
  posthog.identify(username, {
    username: username,
    $set: { // Use $set to ensure properties are updated
      username: username,
      last_login: new Date().toISOString()
    }
  });
}

// Reset user identification
export function resetAnalytics(clearDeviceId = false) {
  posthog.reset(clearDeviceId);
}